module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av611-5fc4ee74541bd41d2ab00c1588266249.jpg";